export default "__VITE_ASSET__DMXmDn00__"